import { Typography, Box, Button } from '@mui/material';
import Styles from '../Locations/Styles/ListCustodiansStyles';
import { cardContainer } from '../../assets/styles/appStyles';
import { useState } from 'react';
import AssociationListTable from './AssociationListTable';
import { useNavigate } from 'react-router';
import AssociationsSearch from './Search/AssociationsSearch';
import useFetchAssociationsSearchResult from '../../hooks/Locations/useFetchAssociationsSearchResult';
import useAuth from '../../hooks/context/useAuth';
import { appActions } from '../../settings/appConfig';

export default function AssociationsList() {
  const { isAuthorized } = useAuth();
  const { data, pageChanged, searchChanged, isLoading } = useFetchAssociationsSearchResult();
  const [associationsPageNo, setAssociationsPageNo] = useState(0);
  const [showNewMapAssociationScreen, setShowNewMapAssociationScreen] = useState(false);
  const navigate = useNavigate();

  const onSearchAssociations = (searchText?: string, stateId?: string) => {
    setAssociationsPageNo(0);
    searchChanged(searchText, stateId);
  }
  if (showNewMapAssociationScreen) {
    navigate("/associations/add");
  }

  return (
    <Box sx={cardContainer} p={2}>
      <Box sx={{ ...Styles.cardStyles, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <Typography sx={Styles.headerTitleStyles}>
          Association Management
        </Typography>
        {(isAuthorized(appActions.addAssociations) || isAuthorized(appActions.editAssociations)) && <Button
          variant="outlined"
          size="medium"
          onClick={() => setShowNewMapAssociationScreen(true)}
          sx={{
            backgroundColor: '#F97316',
            color: 'white',
            borderRadius: '8px',
            textTransform: 'none',
            padding: '8px 20px',
            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
            transition: 'all 0.3s ease',
            '&:hover': {
              backgroundColor: '#D25B10',
              transform: "translateY(-2px)",
              boxShadow: "0px 8px 20px rgba(0, 0, 0, 0.3)",
            },
          }}
        >
          Add New Association
        </Button>}
      </Box>
      <AssociationsSearch
        onSearchChanged={onSearchAssociations}
      />
      <AssociationListTable
        entityRelationships={data.entityRelationships}
        count={data.totalCount}
        onPageChanged={pageChanged}
        isLoading={isLoading}
        pageNo={associationsPageNo}
        setPageNo={setAssociationsPageNo}
        usePagination={true}
        showNoRecordsFoundMessage={true}
      />
    </Box>

  );
}
